// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_zxrGx"};